import React from "react";
import { Item } from "../view";
import { Col, Row, Spin } from "antd";
import { Empty } from "../../../../../assets/svg";
import { numberWithCommas, filterChangeValue } from "../utils";
import { convertToTitleCase, currencyFormat, formatCurrency, formatDateRange } from "../../../../libs/utils";
import { Booking } from "../../../../../types/bookings";

interface IProps {
  booking: Booking;
  newRenewalType?: any;
}

const index = (props: IProps) => {
  const { leaseType, bookingTerms } = props?.booking;
  const isBooking = props?.booking && Object.keys(props.booking).length > 0;
  const valueStyle = { textTransform: "capitalize" };

  return (
    <Col span={24} className="view-booking">
      {!isBooking && (
        <Row gutter={24} className="loading">
          <Spin size="large" />
        </Row>
      )}

      {isBooking && props.booking?.bookingTerms?.renewalAmount && !props?.newRenewalType && (
        <>
          <Row gutter={24} className="bd-item">
            <Item label={`Property Admin`} value={convertToTitleCase(props.booking?.adminManager?.name)} />

            {leaseType && <Item label="Type" value={convertToTitleCase(leaseType)} />}

            <Item
              label="Renewal Term"
              value={formatDateRange(
                props.booking?.leaseTerms?.leaseStartDate,
                props.booking?.leaseTerms?.leaseEndDate
              )}
            />

            {bookingTerms?.numberOfRenewalTerms && bookingTerms?.durationType && (
              <Item
                label="Renewal Duration"
                value={`${bookingTerms.numberOfRenewalTerms} ${bookingTerms.durationType}`}
              />
            )}

            <Item
              label="Current Annual Rent"
              value={currencyFormat(props.booking?.bookingTerms?.annualBaseRent)}
              renewalAmout={props?.booking?.renewalTerms?.tempAnnualBaseRent && currencyFormat(props?.booking?.renewalTerms?.tempAnnualBaseRent)}
            />

            <Item
              label={"Updated Annual Rent"}
              value={currencyFormat(props.booking?.bookingTerms?.renewalAmount)}
              renewalAmout={props?.booking?.renewalTerms?.tempRenewalAmount && currencyFormat(props?.booking?.renewalTerms?.tempRenewalAmount)}
            />
            <Item
              valueStyle={valueStyle}
              label="Change Type"
              value={filterChangeValue(props.booking?.bookingTerms?.changeValue)}
              renewalAmout={filterChangeValue(props?.booking?.renewalTerms?.tempChangeValue)}
            />
            <Item
              valueStyle={valueStyle}
              label="Adjustment Type"
              value={props.booking?.bookingTerms?.amountType}
              renewalAmout={props?.booking?.renewalTerms?.tempAmountType}
            />

            {props.booking?.bookingTerms?.changeValue !== "no_change" && (
              <Item
                label={`${props.booking?.bookingTerms?.amountType} of Adjustment`}
                value={`${props.booking?.bookingTerms?.amountType === "amount" ? "AED" : ""} ${numberWithCommas(
                  props.booking?.bookingTerms?.amountChange
                )}${props.booking?.bookingTerms?.amountType === "percentage" ? "%" : ""}
                `}
                renewalAmout={
                  props?.booking?.renewalTerms?.tempAmountType &&
                  `${props?.booking?.renewalTerms?.tempAmountType === "amount" ? "AED" : ""} ${
                    props?.booking?.renewalTerms?.tempAmountType &&
                    numberWithCommas(props?.booking?.renewalTerms?.tempAmountChange)
                  }
                  ${
                    props?.booking?.renewalTerms?.tempAmountType &&
                    props?.booking?.renewalTerms?.tempAmountType === "percentage"
                      ? "%"
                      : ""
                  }
              `
                }
                amountOfAdjust={props.booking?.bookingTerms?.amountChange}
                renewalAmoutAdjust={props?.booking?.renewalTerms?.tempAmountChange}
                amountTypeCheck={props.booking?.bookingTerms?.amountType}
              />
            )}

            <Item
              label="No. of Instalments"
              value={props.booking?.bookingTerms?.numberOfInstallments}
              renewalAmout={props?.booking?.renewalTerms?.tempNumberOfInstallments}
            />

            {leaseType === "extension" && (
              <Item label="New Contract Rent" value={formatCurrency(bookingTerms.contractRent)} />
            )}

            {bookingTerms?.securityDepositTopUp?.requiredAmount > 0 && (
              <>
                <Item
                  label="Current Deposit Amount"
                  value={currencyFormat(bookingTerms?.securityDepositTopUp?.currentAmount)}
                />
                <Item label="Required Deposit" value={`${bookingTerms?.securityDepositTopUp?.requiredPercentage}%`} />
                <Item
                  label="Top-Up Amount"
                  value={currencyFormat(bookingTerms?.securityDepositTopUp?.requiredAmount)}
                />
              </>
            )}
          </Row>
        </>
      )}

      {((isBooking && !props.booking?.bookingTerms?.renewalAmount) || props?.newRenewalType) && (
        <Row style={{ justifyContent: "center" }}>
          <Empty width="200px" height="200px" style={{ alignContent: "center" }} />
        </Row>
      )}
    </Col>
  );
};

export default index;
